import { render, staticRenderFns, recyclableRender, components } from "./vip.vue?vue&type=template&id=f54de65c&scoped=true&"
var renderjs
import script from "./vip.vue?vue&type=script&lang=js&"
export * from "./vip.vue?vue&type=script&lang=js&"
import style0 from "./vip.vue?vue&type=style&index=0&id=f54de65c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../下载/Edge下载/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54de65c",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/user/vip.vue"
export default component.exports